var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_discover",
    "data-name": "vuesax/outline/discover",
    transform: "translate(-428 -508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "discover",
    transform: "translate(428 508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.11,35.4a6.065,6.065,0,0,1-4.421-1.686C.1,32.125-.39,29.7.314,26.886l4.06-16.258a9.323,9.323,0,0,1,6.254-6.254L26.886.314C29.7-.39,32.126.1,33.714,1.689S35.793,5.7,35.089,8.516l-4.06,16.258a9.323,9.323,0,0,1-6.254,6.254L8.516,35.089A10.555,10.555,0,0,1,6.11,35.4Zm21.4-32.729L11.251,6.748a6.978,6.978,0,0,0-4.486,4.47L2.7,27.476c-.491,1.948-.229,3.536.72,4.5.95.95,2.554,1.212,4.5.72l16.258-4.06a6.954,6.954,0,0,0,4.47-4.47L32.715,7.91c.491-1.948.229-3.536-.72-4.5S29.457,2.2,27.509,2.671Z",
    transform: "translate(2.279 2.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M8.22,16.44a8.22,8.22,0,1,1,8.22-8.22A8.238,8.238,0,0,1,8.22,16.44ZM8.22,2.9A5.319,5.319,0,1,0,13.539,8.22,5.316,5.316,0,0,0,8.22,2.9Z",
    transform: "translate(11.78 11.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H40V40H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.e9e0b91b680d6008d8b37bc105012b56.svg";
export { ForwardRef as ReactComponent };